module.exports = __webpack_public_path__ + "assets/img/Claim_btn.eaa34c43.png";